<template>
  <vx-card id="crash-loading" class="w-full crash-loading">
    <div class="logo-full logo-crash mt-5"></div>
    <div class="">
      <div class="content-quotes">
        <div class="mt-5 mb-5" v-if="displayLoadingBar">
          <div class="loading-bar">
            <span class="background-loading-bar">
              <span
                class="loading-bar-inner progress-bar-stripes progress-bar-danger"
              ></span>
            </span>
          </div>
        </div>
        <h4 class="mt-4 mb-4 ">
          <p> <span v-if="currentErrorCode">{{ currentErrorCode }} - </span>{{ title }}</p>
          <p>{{ desc }}</p>
        </h4>
        <div class="mt-5 mb-5 button-action-content">
          <vs-button v-if="displayReconectButton" class="m-2" color="primary" @click.stop="$emit('connect')">{{
            btnConnectText ? btnConnectText :
              $t('WDMA').Error_System_Button_Connect }}</vs-button>
          <vs-button class="m-2" color="primary" @click.stop="$emit('openAttendance', textAttendance)">{{
            btnOpenAttendanceText ?
              btnOpenAttendanceText : $t('WDMA').Error_System_Button_Attendance }}</vs-button>
        </div>
      </div>
    </div>
  </vx-card>
</template>
<script>
import VxCard from "../../../components/vx-card/VxCard.vue";

export default {
  components: { 
    VxCard,
  },
  props: {
    title: {
      require: true,
      type: String
    },
    desc: {
      require: true,
      type: String
    },
    displayReconectButton: {
      type: Boolean,
      default: true
    },
    displayLoadingBar: {
      type: Boolean,
      default: false
    },
    btnConnectText: {
      type: String
    },
    btnOpenAttendanceText: {
      type: String
    },
    textAttendance: {
      type: String
    },
    currentErrorCode: {
      type: Number
    },
  },
}
</script>